<!--确认安装页-->
<template>
    <div style="height: 100%;width: 100%">


        <div>

            <van-sticky><!-- 粘性布局，顶部的位置固定 -->
                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="18">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="value"
                                        placeholder="车牌号\车架号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <!-- icon图标，刷新页面 -->
                                <van-icon name="replay" size="15px" @click="reststart"/>
                            </div>
                        </van-col>
                    </van-row>

                    <!-- 下拉菜单 -->
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="value1" :options="option1" @change="check"/>
                    </van-dropdown-menu>

                </div>
            </van-sticky>
        </div>


        <div style="background-color: #f8f8f9">
            <van-pull-refresh v-model="isLoading" @refresh="refresh"><!-- 下拉刷新 -->
                <!-- 上拉加载 -->
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <!-- 加载图标 -->
                    <van-loading class="loader" v-if="loader"/>
                    <div v-for="(item,index) in installlist" class="content">
                        <Card style="width:100%">
                            <label>订单号:
                                <label style="color: #0077aa;">{{item.orderNum}}</label>
                            </label><br/>
                            <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.registrationNum:item.vehicleInfo.registrationNum}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr">|</span>
                                <span class="count fl">车辆识别码:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.identificationCode:item.vehicleInfo.identificationCode}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                            </div>
                            <div class="mid">
                                <span class="time fr">车架号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.vin:item.vehicleInfo.vin}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.engineNum:item.vehicleInfo.engineNum}}</label>
                                </span>
                            </div>


                            <div class="mid">
                                <span class="count fl">安装状态:<label style="color: #0077aa;">{{item.installed===true?'已安装':'未安装'}}</label></span>
                                <span class="count fl" v-if="item.urgent"><label style="color: red;">({{item.urgent===true?'加急':'普通'}})</label></span>
                                <span class="distance fr">&nbsp;|&nbsp;</span>
                                <span class="time fr">安装员:<label style="color: #0077aa;">{{item.installer===null?'未指派':item.installer.realName}}</label></span>
                            </div>

                            <div class="mid">
                                <span class="count fl" v-if="item.setupDatetime">安装时间:<label style="color: #0077aa;">{{item.setupDatetime == null?'无':new Date(item.setupDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}</label></span>
                            </div>
                            <div class="mid" v-if="item.bookingDatetime || item.actualDatetime">
                                <span class="count fl" v-if="!item.actualDatetime">
                                    预约时间:
                                    <label style="color: #0077aa;">{{item.bookingDatetime == null?'无':new Date(item.bookingDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}
                                    </label>
                                </span>
                                <span v-else>
                                    重新预约时间:
                                    <label style="color: #0077aa;">{{item.actualDatetime == null?'无':new Date(item.actualDatetime).Format('yyyy年MM月dd日 hh:mm:ss')}}
                                    </label>
                                </span>
                            </div>
                            <div class="mid" v-if="item.bookingPlace || item.actualPlace">
                                <span class="count fl" v-if="!item.actualDatetime">
                                    预约地点:
                                    <label style="color: #0077aa;">{{item.bookingPlace == null?'无':item.bookingPlace}}
                                    </label>
                                </span>
                                <span v-else>
                                    重新预约地点:
                                    <label style="color: #0077aa;">{{item.actualPlace == null?'无':item.actualPlace}}
                                    </label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">订单状态:
                                    <label v-for="state in stateOption">
                                        <label v-if="state.value === item.state" style="color: red">
                                        {{state.text}}{{item.step == null ? '' : item.step.state ==1 ? '中' : item.step.state ==2 ? '成功' : item.step.state ==3 ? '失败' : ''}}
                                        </label>
                                    </label>
                                </span>

                                <span v-if="item.step ==null ? false : item.step.state != 3 ? false : true">
                                    <label>
                                        失败原因：
                                        <label style="color: red">
                                        {{item.step.result}}
                                        </label>
                                    </label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="time fr"> 配机:<label style="color: #0077aa;">{{item.positioningDeviceInfosCount===0?'未分配':'已分配'}}</label></span>
                                <span class="distance fr">|</span>
                                <span class="time fr"> 业务类型:<label style="color: #0077aa;">{{item.businessType===1?'新装':item.businessType===2?'接入':'在网升级'}}</label></span>
                            </div>
                            <div class="mid">
                                <span class="time fr">安装图片:<label :class="[item.installOrderPics.length==0?'s4':'s2']">
                                    {{item.installOrderPics.length==0?'未上传安装图片':'已上传：'+item.installOrderPics.length+'张'}}
                                </label></span>
                            </div>
                            <div class="mid" v-if="item.positioningDeviceInfos!=null">
                                <span class="time fr">主机:<label style="color: #0077aa;" v-for="item2 in item.positioningDeviceInfos">

                      {{item2.terminalNum+'('+item2.positioningDeviceModel.name+')'}}

                                </label></span>
                            </div>
                            <div class="mid">
                                <span class="count fl">备注:
                                    <label style="color: #0077aa;">{{item.remark==null?'':item.remark}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <div style="position: relative;left: 25%;margin-bottom: 5px;">
                                    <van-button size="small" type="info" style="margin-right: 5px;"
                                                :disabled="disabled" @click="onChangeInstallerModal(item)">指派安装员
                                    </van-button>
                                    <van-button size="small" type="info"
                                                :disabled="disabled" @click="onReschedule(item)">重新预约
                                    </van-button>
                                </div>
                                <div style="position: relative;left: 25%;">
                                    <a :href="'../installerinstallorderdetails?installid='+item.id" style="padding-right: 5px;">
                                        <van-button size="small" type="info"
                                                    :disabled="disabled" >订单详情
                                        </van-button>
                                    </a>
                                    <a :href="'../installerinstallorderconfirm?installid='+item.id">
                                        <van-button size="small" type="info" style="margin-right: 5px;"
                                                    :disabled="disabled">确认流程
                                        </van-button>
                                    </a>
                                    <van-button size="small" type="info"
                                                :disabled="disabled" @click="sueeess(item)">确认安装
                                    </van-button>
                                </div>
                            </div>

                        </Card>
                        <div style="height: 3px"></div>
                    </div>


                </van-list>
            </van-pull-refresh>
        </div>


        <Modal
                v-model="modal2"
                title="添加备注"
                @on-ok="ok1"
                @on-cancel="cancel1">
            <van-cell-group>
                <van-field
                        v-model="remarkvalue"
                        rows="2"
                        autosize
                        type="textarea"
                        maxlength="250"
                        placeholder="请输入追加备注"
                        show-word-limit
                />
            </van-cell-group>
        </Modal>
        <bind-positioning-devices-modal v-model="bindPositioningDevicesModal" :initValue="bindPositioningDevicesId"
                                        @on-success="onModifySuccess"></bind-positioning-devices-modal>
        <bind-positioning-devices-fittings-modal v-model="bindPositioningDevicesFittingsModal"
                                                 :initValue="bindPositioningDevicesFittingsId"
                                                 @on-success="onModifySuccess"></bind-positioning-devices-fittings-modal>
        <vehicle-identificationcode-modal v-model="vehicleIdentificationcodeModal"
                                          :installed="vehicleIdentificationcodeInstalled"
                                          :initValue="vehicleIdentificationcodeId"
                                          @on-success="onModifySuccess"></vehicle-identificationcode-modal>
        <positioning-device-info-aisle-modal v-model="positioningDeviceInfoAisleModal"
                                             :initValue="positioningDeviceInfoAisleId"></positioning-device-info-aisle-modal>
        <change-installer-modal v-model="changeInstallerModal" :initValue="changeInstallerId"
                                @on-success="reststart"></change-installer-modal>
        <reschedule-installer-modal v-model="rescheduleinstallermodal" :initValue="rescheduleinstallerId"
                                    @on-success="reststart"></reschedule-installer-modal>
    </div>
</template>

<script>
    import BindPositioningDevicesModal from '@/views/im/components/bind-positioning-devices-modal'
    import BindPositioningDevicesFittingsModal from '@/views/im/components/bind-positioning-devices-fittings-modal'
    import VehicleIdentificationcodeModal from '@/views/crm/components/vehicle-identificationcode-modal'
    import PositioningDeviceInfoAisleModal from '@/views/im/components/positioning-device-info-aisle-modal'
    import ChangeInstallerModal from '@/views/om/install-order/components/change-installer-modal'
    import RescheduleInstallerModal from '@/views/om/installer-install-order/components/reschedule-installer-modal'

    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'

    const wx = require('weixin-js-sdk')
    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "installerinstallorder",
        components: {
            BindPositioningDevicesModal,
            BindPositioningDevicesFittingsModal,
            VehicleIdentificationcodeModal,
            PositioningDeviceInfoAisleModal,
            ChangeInstallerModal,
            RescheduleInstallerModal,
        },
        data() {
            return {
                //重新预约安装订单
                rescheduleinstallermodal: false,
                rescheduleinstallerId: null,

                //指派安装员
                changeInstallerModal: false,
                changeInstallerId: null,

                // 设备通道
                positioningDeviceInfoAisleModal: false,
                positioningDeviceInfoAisleId: null,

                // 车辆识别码
                vehicleIdentificationcodeModal: false,
                vehicleIdentificationcodeId: null,
                vehicleIdentificationcodeInstalled: false,

                // 安装订单配置设备
                bindPositioningDevicesModal: false,
                bindPositioningDevicesId: null,

                // 安装订单配置定位设备配件
                bindPositioningDevicesFittingsModal: false,
                bindPositioningDevicesFittingsId: null,

                disabled: false,
                disabled1: false,
                state: '',
                lastRecvDatetime: null,
                readonly: true,
                value: '',
                // value2: '',
                // installid: '',
                installlist: [],
                showbutton: false,
                // modal1: false,

                discern: false,
                activeName: [],


                value1: 0,
                option1: [
                    {text: '未完成安装', value: 0},
                    {text: '已完成安装', value: 1},
                ],

                i: [],
                loading: false,
                finished: false,
                loader: false,
                isLoading: false,

                modal2: false,
                remarkid: '',
                remarkvalue: '',

                stateOption:[
                    {text: '异常', value: -1},
                    {text: '作废', value: 0},
                    {text: '指派', value: 1},
                    {text: '完成', value: 2},
                    {text: '审核', value: 3},
                    {text: '配货', value: 4},
                    {text: '安装', value: 5},
                    {text: '回访', value: 6},
                    {text: '收款', value: 7},
                    ]
            }
        },
        methods: {
            onChangeInstallerModal(e){
                this.changeInstallerModal = true
                this.changeInstallerId = e.id
            },
            //重新预约安装
            onReschedule(e){
                this.rescheduleinstallermodal = true
                this.rescheduleinstallerId = e.id
            },
            tosetterorderDetails(e) {
                // console.log(e)
                // this.$router.push({
                //     name: 'setterorderDetails',
                //     params: {'installid': e.id}
                // })
            },
            tosetupVehicleParams(e) {

                let qq = []
                qq.push(genQueryParam('terminalNum', 'EQ', e.positioningDeviceInfos[0].terminalNum))
                store.dispatch('Jt808DeviceServ_GetPage', {
                    params: null,
                    urlparams: {
                        q: qq
                    }
                }).then((res) => {
                    if (res.data.content.length != 0) {
                        this.$router.push({
                            path: 'setupVehicleParams',
                            query: {'upVehicleParams': e}
                        })
                    } else {
                        Toast('设备未有上线记录')
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            // <!-- 下拉刷新方法 -->
            refresh() {
                // this.check()
                setTimeout(() => {
                    this.i = []
                    this.installlist = []
                    this.finished = false;
                    this.onLoad()
                    this.isLoading = false
                }, 500)
            },
            // <!-- icon图标刷新方法 -->
            reststart() {
                this.loader = true
                setTimeout(() => {
                    // this.check()
                    this.i = []
                    this.installlist = []
                    this.finished = false;
                    this.onLoad()
                    this.loader = false
                }, 500);
            },
            // <!-- 上拉加载方法 -->
            onLoad() {
                this.i.push(1)
                // this.installlist = []
                if (this.value1 == 0) {
                    // setTimeout(() => {

                    let bb
                    let qq = []
                    qq.push(genQueryParam('installed', 'EQBOOL', false))
                    qq.push(genQueryParam('state', 'NEQ', 0))
                    //获取我安装的分页
                    store.dispatch('InstallOrderServ_GetMyInstallPage', {
                        params: null,
                        urlparams: {
                            q: qq,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {

                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 1) {
                    // setTimeout(() => {

                    let bb
                    let qq = []
                    qq.push(genQueryParam('installed', 'EQBOOL', true))
                    qq.push(genQueryParam('state', 'NEQ', 0))
                    //获取我安装的分页
                    store.dispatch('InstallOrderServ_GetMyInstallPage', {
                        params: null,
                        urlparams: {
                            q: qq,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                }

            },

            check(e) {
                this.i = []
                this.installlist = []
                this.finished = false;
                this.onLoad()
                // if (e == 0) {
                //     let qq = []
                //     qq.push(genQueryParam('installed', 'EQBOOL', false))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我安装的分页
                //     store.dispatch('InstallOrderServ_GetMyInstallPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (e == 1) {
                //     let qq = []
                //     qq.push(genQueryParam('installed', 'EQBOOL', true))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我安装的分页
                //     store.dispatch('InstallOrderServ_GetMyInstallPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // }
            },

            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            onVehicleidentificationcodemodal(e) {
// console.log(e)
                if (e.vehicleInfoId != null) {
                    this.vehicleIdentificationcodeInstalled = true
                    this.vehicleIdentificationcodeId = e.vehicleInfoId
                    this.vehicleIdentificationcodeModal = true
                } else {
                    this.vehicleIdentificationcodeInstalled = false
                    this.vehicleIdentificationcodeId = e.id
                    this.vehicleIdentificationcodeModal = true
                }
            },
            onPositioningDeviceInfoAisleModal(e) {
                console.log(e)
                if (e.positioningDeviceInfos != null && e.positioningDeviceInfos.length > 0) {
                    this.positioningDeviceInfoAisleModal = true
                    this.positioningDeviceInfoAisleId = e.id
                } else {
                    this.$Message.error('没有绑定设备')
                }
            },
            //  确认安装
            sueeess(e) {

                // console.log(e)
                // this.$router.push({
                //     name: 'installerinstallorderconfirm',
                //     params: {'installid': e.id}
                // })
                this.disabled = true
                console.log(e)
                // this.modal1 = true
                //按名称搜索定位设备信息
                if (e.positioningDeviceInfosCount != null) {

                    if (e.step != null) {
                        e.step.state = 2
                    }
                    //确认安装完成
                    store.dispatch('InstallOrderServ_ConfirmInstalled', {
                        params: e,
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        Toast('确认成功')
                        this.disabled = false
                        // this.value2 = ''
                        this.onFind()
                    }).catch((err) => {
                        console.log(err)
                        // this.value2 = ''
                        this.disabled = false
                        Toast('确认失败' + err)
                    })
                } else {
                    Toast('未配定设备');
                }
            },

            // //最终安装确认
            // ok() {
            //     //确认安装完成
            //     store.dispatch('InstallOrderServ_ConfirmInstalled', {
            //         params: {
            //             id: this.installid,
            //             setupDatetime: new Date()
            //         },
            //         urlparams: null
            //     }).then((res) => {
            //         console.log(res)
            //         Toast('确认成功')
            //         this.value2 = ''
            //         this.onFind()
            //     }).catch((err) => {
            //         console.log(err)
            //         this.value2 = ''
            //         Toast(err)
            //     })
            // },
            //
            // //最终安装取消
            // cancel() {
            //     this.value2 = ''
            // },

            //搜索取消
            onCancel() {
                this.value = ''
                this.start()
            },
            // <!-- 搜索方法，默认state为0，排除作废订单 -->
            onFind() {
                this.i = []
                this.installlist = []
                this.finished = false;
                this.onLoad()

                // if (this.value1 == 0) {
                //     let qq = []
                //     qq.push(genQueryParam('installed', 'EQBOOL', false))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我安装的分页
                //     store.dispatch('InstallOrderServ_GetMyInstallPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 1) {
                //     let qq = []
                //     qq.push(genQueryParam('installed', 'EQBOOL', true))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我安装的分页
                //     store.dispatch('InstallOrderServ_GetMyInstallPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // }
            },

            //上传图片路径
            toUploaderimage(e) {
                console.log(e)
                this.$root.installid = e
                this.$router.push({
                    path: '/setter-Uploaderimage',
                    query: {'item': e.id}
                })
            },

            //上传图片新样式
            toTextUploaderimage(e) {
                console.log(e)
                this.$root.installid = e
                this.$router.push({
                    path: '/text-Upladerimage',
                    query: {'item': e.id}
                })
            },

            toUploaderInstallOrderImage(e) {
                // console.log(e)
                // this.$root.installid = e
                // this.$router.push({
                //     path: '/UploaderInstallOrderImage',
                //     query: {'item': e.id}
                // })

                // var appid = 'wx35df9038a4f73847'
                // var noncestr = 'UploaderInstallOrderImage' + Date.parse(new Date())/1000
                // var timestamp = Date.parse(new Date())/1000
                // // let url = location.href.split('#')[0]
                // var u = navigator.userAgent;
                // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                // let url=''
                // if (isAndroid) {
                //     alert('安卓')
                //     url=location.href
                // }
                // alert(Vue.prototype.href)
                // alert( window.location.href)
                // Vue.prototype.href = window.location.href
                // if (isIOS) {
                //     alert('IOS')
                //     url=window.location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
                //     alert(url)
                // }
                // // this.$http.get('https://devwxpa.jianchengjt.com/UploaderInstallOrderImage',{
                // //     params: {
                // //         item: this.$route.query.item
                // //     }
                // // }).then(response => {
                // //     console.log(response)
                // //     let res = response.data;
                // // wx.config({
                // //     debug: false,
                // //     appId: appid,
                // //     timestamp: res.timestamp,
                // //     nonceStr: res.nonceStr,
                // //     signature: res.signature,
                // //     jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone','chooseImage','previewImage','uploadImage','downloadImage']
                // // });
                // // })
                // store.dispatch('MediaPlatformServ_GetSignature',{
                //     urlparams:{
                //         noncestr:noncestr,
                //         timestamp:timestamp,
                //         url:url,
                //     }
                // }).then(res=>{
                //     console.log(res)
                //     // alert(res.data)
                //     wx.config({
                //         debug: true,
                //         appId: appid,
                //         timestamp: timestamp,
                //         nonceStr: noncestr,
                //         signature: res.data,
                //         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone','chooseImage','previewImage','uploadImage','downloadImage'],
                //         success: function (res) {
                //             console.log(res)
                //         },
                //         fail:function (err) {
                //             console.log(err)
                //         }
                //     });
                // }).catch(err=>{
                //     console.log(err)
                // })
                //
                // // wx.getLocalImgData({
                // //     localId: '', // 图片的localID
                // //     success: function (res) {
                // //         console.log(res)
                // //         var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                // //     }
                // // });
                // wx.ready(function(){
                //     // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                //     wx.chooseImage({
                //         count: 9, // 默认9
                //         sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                //         sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                //         success: function (res) {
                //             console.log(res)
                //             var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                //
                //             //IOS预览图片
                //             wx.getLocalImgData({
                //                 localId: req.localIds[0].toString(),
                //                 success: function (res) {
                //                     const localData = res.localData;
                //                     let imageBase64 = '';
                //                     if (localData.indexOf('data:image') == 0) {
                //                         //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                //                         imageBase64 = localData;
                //                         console.log(imageBase64)
                //                     } else {
                //                         //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                //                         //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                //                         imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                //                         console.log(imageBase64)
                //                     }
                //                 }
                //             });
                //
                //         },
                //         fail:function (err) {
                //             console.log(err)
                //         }
                //     });
                // });
                // wx.error(function(res){
                //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                //     console.log(res)
                // });


            },

            //识别行车证
            onAnalyzeVehicleLicensePicture(e) {
                this.discern = true
                //车辆信息
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: e},
                    urlparams: null
                }).then((res) => {


                    if (res.data.vehicleInfoId) {
                        //已完成的订单
                        //  识别行驶证
                        store.dispatch('VehicleInfoServ_AnalyzeVehicleLicensePicture', {
                            params: {id: res.data.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            this.discern = false
                            this.onFind()
                        }).catch((err) => {
                            Toast(err)
                            this.discern = false
                        })
                    } else {
                        //未完成的订单

                        let installOrder = store.getters.get_InstallOrder_GetDetailResult
                        this.installOrder = installOrder
                        let vehicleInfo = this.installOrder.tempVehicleInfo
                        if (vehicleInfo.vehicleLicensePicture) {
                            //  识别行驶证
                            store.dispatch('InstallOrderServ_AnalyzeVehicleLicensePicture', {
                                params: {id: e},
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                this.discern = false
                                this.onFind()
                            }).catch((err) => {
                                Toast(err + '请重新上传');
                                // this.$Message.error(err + '请重新上传');
                                this.discern = false
                            })
                        } else {
                            Toast('未上传行驶证');
                            // this.$Message.warning('未上传行驶证');
                            this.discern = false
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    this.discern = false
                })
            },

            //缺少资料文字转换
            text1(item) {

                let text = ''
                if (item.tempVehicleInfo != null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                }
                return text
                // }
            },
            text2(item) {

                let text = ''
                if (item.tempVehicleInfo != null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                }
                return text
                // }
            },
            text3(item) {

                let text = ''
                if (item.tempVehicleInfo != null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                    if (!item.tempVehicleInfo.idFilePictureId) {
                        text = text + ' 身份识别文件'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeContractPictureId) {
                        text = text + ' 转网合同'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeAuthorizationPictureId) {
                        text = text + ' 授权书'
                    }
                }
                return text
                // }
            },
            //追加备注
            addremark(e) {
                this.modal2 = true
                this.remarkid = e.id
            },
            ok1() {
                store.dispatch('InstallOrderServ_AddToInstallRemark', {
                    params: {
                        id: this.remarkid,
                        content: this.remarkvalue
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.remarkvalue = ''
                    this.onFind()
                }).catch((err) => {
                    console.log(err)
                })
            },
            //添加备注取消
            cancel1() {
                this.remarkvalue = ''
            },
            // start(){
            //     let aa=[]
            //     aa.push(genQueryParam('state','NEQ','0'))
            //     //获取我安装的分页
            //     store.dispatch('InstallOrderServ_GetMyInstallPage', {
            //         params: null,
            //         urlparams: {
            //             q:aa
            //         }
            //     }).then((res) => {
            //         console.log(res)
            //         this.installlist=res.data.content
            //     })
            //         .catch((err) => {
            //             console.log(err)
            //         })
            // },
            //配机
            onBindPositioningDevicesModal(e) {
                this.bindPositioningDevicesModal = true
                this.bindPositioningDevicesId = e.id
            },
            onBindPositioningDevicesFittingsModal(e) {
                this.bindPositioningDevicesFittingsId = e.id
                this.bindPositioningDevicesFittingsModal = true
            },

        },

        mounted() {
            this.$nextTick(() => {
                // this.start()


            })
        }
    }
</script>

<style>
    .s1 {
        color: blue;
    }

    .s2 {
        color: yellowgreen;
    }

    .s3 {
        color: blueviolet;
    }

    .s4 {
        color: red;
    }


    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    .content .name {
        font-size: 17px;
        color: #333;
        overflow: hidden;
        font-weight: bold;
        overflow: hidden;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .conopen {
        text-align: right;
    }

    .loader {
        text-align: center;
    }

    .wrapper {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 115px;
        bottom: 50px; /*关键*/
        overflow: hidden;
        z-index: 1;
    }
</style>

